import { 
    PUBLISH_FAIL, PUBLISH_REQUEST, PUBLISH_SUCCESS
  } from "../constant";
  
  const initialState = {
    publishData: 2,
    showLandingPage:0
  }
  
  const publishReducer = (state = initialState, action) => {
    switch (action.type) {
      case PUBLISH_REQUEST:
        return state
  
      case PUBLISH_FAIL:
        return  state
  
      case PUBLISH_SUCCESS:
        console.log('action?.payload', action?.payload[0]);
        return {
          ...state,
          publishData :action?.payload?.[0].su_is_active,
          showLandingPage: action?.payload[0]?.su_is_landing_page
        }

      default:
        return state;
    }
  }
  
  export default publishReducer